import React, { useCallback, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import MyDigitalCardGeneral from './MyDigitalCardGeneral';
import MyDigitalCardBusiness from './MyDigitalCardBusiness';
import MyDigitalCardStudent from './MyDigitalCardStudent';
import MyDigitalCardWomen from './MyDigitalCardWomen';
import MyDigitalCardChildren from './MyDigitalCardChildren';
import MyDigitalCardBlue from './MyDigitalCardBlue';
import MyDigitalCardFarmer from './MyDigitalCardFarmer';

import MyDigitalCardHindu from './MyDigitalCardHindu';
import MyDigitalCardMuslim from './MyDigitalCardMuslim';
import MyDigitalCardChristian from './MyDigitalCardChristian';
import MyDigitalCardSikh from './MyDigitalCardSikh';
import MyDigitalCardJain from './MyDigitalCardJain';
import MyDigitalCardPatriotic from './MyDigitalCardPatriotic';
import MyDigitalCardTalking from './MyDigitalCardTalking';
import MyDigitalCardMarriage from './MyDigitalCardMarriage';

import '../../styles/MyProfile.css';

const CardPage = () => {
  const [loading, setLoading] = useState(true);
  const { cardType } = useParams();

  const renderCardComponent = () => {
    switch (cardType) {
      case 'general':
        return <MyDigitalCardGeneral/>;
      case 'business':
        return <MyDigitalCardBusiness/>;
      case 'blue':
        return <MyDigitalCardBlue/>;
      case 'farmer':
        return <MyDigitalCardFarmer/>;        
      case 'student':
        return <MyDigitalCardStudent/>;
      case 'women':
        return <MyDigitalCardWomen/>;
      case 'children':
        return <MyDigitalCardChildren/>;
      case 'hindu':
        return <MyDigitalCardHindu/>;
      case 'muslim':
        return <MyDigitalCardMuslim/>;
      case 'sikh':
        return <MyDigitalCardSikh/>;
      case 'christian':
        return <MyDigitalCardChristian/>;
      case 'jain':
        return <MyDigitalCardJain/>;
      case 'patriotic':
        return <MyDigitalCardPatriotic/>;
      case 'talking':
        return <MyDigitalCardTalking/>;
      case 'marriage':
        return <MyDigitalCardMarriage/>;
      default:
        return <MyDigitalCardGeneral/>;
    }
  };

  return (
    <div>
      <div className="flex flex-col justify-center items-center min-h-screen p-4 relative">
         {renderCardComponent()}
      </div>
    </div>
  );
};

export default CardPage;
